export class NavigationHistory {

    constructor() {
        this._stack = [];
    }

    push(entry) {
        this._stack.push(entry);
    }

    pop() {
        return this._stack.length > 0 ? this._stack.pop() : null;
    }

    peek() {
        return this._stack.length > 0 ? this._stack[this._stack.length - 1] : null;
    }

    clear() {
        this._stack = [];
    }

    get canGoBack() {
        return this._stack.length > 0;
    }

    get length() {
        return this._stack.length;
    }
}
